import MenuItem from '@mui/material/MenuItem';
import s from './MLMenuItem.module.css';
function MLMenuItem({ children, ...props }) {
  return (
    <MenuItem
      classes={{ root: s.root }}
      ListItemClasses={{ disabled: s.menuItemDisabled }}
      {...props}
    >
      {children}
    </MenuItem>
  );
}

export default MLMenuItem;
